import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Button, Text, Divider
} from 'components/ui';
import Radio from 'components/Inputs/Radio/Radio';
import PaymentDetails from 'components/FrictionlessCheckout/PaymentReleaseFour/PaymentDetails';

const SavedAlternatePaymentRadio = ({
    paymentName,
    defaultPayment,
    selected,
    onClick,
    onUseThisPaymentMethod,
    installmentValue,
    username,
    isPayPal,
    isGiftCardCombinable,
    locales
}) => {
    return (
        <>
            <Box paddingTop={4}>
                <Radio
                    paddingY={0}
                    dotOffset={0}
                    alignItems='center'
                    name='savedAlternatePayment'
                    checked={selected}
                    onClick={onClick}
                    tabIndex={0}
                    data-at={Sephora.debug.dataAt('saved_alternate_payment_radio')}
                >
                    <PaymentDetails
                        paymentName={!isPayPal && paymentName}
                        defaultPayment={defaultPayment}
                        selected={selected}
                        checkoutEnabled={true}
                        installmentValue={installmentValue}
                        username={username}
                        isSaveState={true}
                        isPayPal={isPayPal}
                        paypalEmail={isPayPal && username}
                    />
                </Radio>

                {selected && (
                    <>
                        <Box
                            marginTop={4}
                            marginBottom={4}
                        >
                            <Button
                                variant='primary'
                                width={['100%', '100%', '380px']}
                                onClick={onUseThisPaymentMethod}
                                data-at={Sephora.debug.dataAt('use_this_payment_method_btn')}
                            >
                                {locales.useThisPaymentMethod}
                            </Button>
                        </Box>

                        {!isGiftCardCombinable && (
                            <Text
                                is='p'
                                fontSize='sm'
                                color='gray'
                                marginBottom={4}
                                data-at={Sephora.debug.dataAt('gift_cards_not_combinable_msg')}
                            >
                                {locales.giftCardsNotCombinable}
                            </Text>
                        )}
                    </>
                )}
            </Box>

            <Divider marginTop={selected ? 0 : 4} />
        </>
    );
};

SavedAlternatePaymentRadio.propTypes = {
    paymentName: PropTypes.string.isRequired,
    defaultPayment: PropTypes.string,
    selected: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onUseThisPaymentMethod: PropTypes.func.isRequired,
    installmentValue: PropTypes.string,
    username: PropTypes.string,
    isGiftCardCombinable: PropTypes.bool,
    locales: PropTypes.object.isRequired
};

export default wrapFunctionalComponent(SavedAlternatePaymentRadio, 'SavedAlternatePaymentRadio');
